export const retrieveErrorMessage = (err, initErrorMsg) => {
    let errMsg = initErrorMsg
    if (err.response && err.response.data) {
        let data = err.response.data;
        if (typeof data === 'string') {
            try {
                data = JSON.parse(data);
            } catch {
                // keep as string if not JSON
            }
        }
        if (typeof data === 'object' && data.message) {
            errMsg = data.message;
        } else if (typeof data === 'string') {
            errMsg = data;
        }
    }
    return errMsg
}